export default __webpack_public_path__ + "static/media/ruler.de4d4cc6.svg";